import { SettingsPanel } from "../features/settings/SettingsPanel";

export function SettingsPage() {
  return <SettingsPanel />;
}
